import { gsap } from 'gsap'
import scrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(scrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

// create line
const createLine = (current, next) => {
  let coorStartTopLine = current.top
  let coorStartLeftLine = current.left
  let coorEndTopLine = next.top
  let coorEndLeftLine = next.left

  let widthLine = 3
  if (window.matchMedia('(max-width: 1399px)').matches) {
    widthLine = 2
  }

  let left = `${coorStartLeftLine}px`
  let right = 'auto'
  let height = widthLine
  let width = widthLine

  if (coorEndLeftLine == coorStartLeftLine) {
    height = coorEndTopLine - coorStartTopLine
  } else {

    if (coorStartLeftLine > coorEndLeftLine) {
      width = coorStartLeftLine - coorEndLeftLine + widthLine
    } else {
      width = coorEndLeftLine - coorStartLeftLine + widthLine
    }

    if (current.moveTo == 'left') {
      right = `${document.body.clientWidth - coorStartLeftLine - widthLine}px`
      left = 'auto'
    }
  }

  const line = document.createElement('div')
  line.className = 'generate-line js-generate-line'
  line.dataset.index = current.index
  line.dataset.heightEnd = `${height}px`
  line.dataset.widthEnd = `${width}px`
  line.style.cssText = `
        height: ${widthLine}px;
        left: ${left};
        right: ${right};
        top: ${coorStartTopLine}px;
        width: ${widthLine}px;
    `

  document.body.appendChild(line)
}

// get coors dots
const getCoorsDots = (selectors) => {

  if (!selectors) return

  const widthBlock = $('.js-nav-help-block').outerWidth(true)
  const heightBlock = $('.js-nav-help-block').outerHeight(true)
  let coorBlocks = []

  $(selectors).each(function (index) {
    let elem = $(this)
    let count = index + 1

    elem.text(count)
    elem.data('index', count)

    const coorElem = elem.offset()

    coorBlocks.push({
      'top': coorElem.top + heightBlock / 2,
      'left': coorElem.left + widthBlock / 2,
      'nextDotStart': elem.data('next-dot-start'),
      'moveTo': elem.data('move-to'),
      'index': count,
    })

  })

  let newArrBlocks = []

  if (window.matchMedia('(max-width: 1399px)').matches) {
    newArrBlocks = coorBlocks
  } else {
    coorBlocks.map((block, index) => {
      const { top, left, moveTo } = block
      newArrBlocks.push({ top, left, moveTo, index: (index + 1) })

      if (!coorBlocks[index + 1]) return

      const nextDotStart = block.nextDotStart?.split(', ')
      let topNewDot = block.top
      let leftNewDot = block.left

      nextDotStart.map(a => {
        switch (a) {
          case 'bottom':
            topNewDot = coorBlocks[index + 1].top
            break

          case 'left':
            leftNewDot = block.left
            break

          case 'right':
            leftNewDot = coorBlocks[index + 1].left

            break

          default:
            break
        }
      })

      newArrBlocks.push({ 'top': topNewDot, 'left': leftNewDot, 'index': block.index, 'moveTo': block.moveTo })
    })
  }
  return newArrBlocks
}

const animateLines = () => {
  $('.js-nav-help-block').closest('.tr-tl-block-js').each(function () {
    const tl = gsap.timeline({
      paused: true,
      stagger: 0.24,
      defaults: {
        duration: 1,
      },
    })

    let index = $(this).find('.js-nav-help-block').data('index')
    let lines = $(`.js-generate-line[data-index="${index}"]`)

    lines.each(function () {
      tl
        .to($(this), {
          height: $(this).data('height-end'),
          width: $(this).data('width-end'),
          opacity: 1,
          duration: 0.3,
        })
    })

    scrollTrigger.create({
      trigger: $(this),
      markers: false,
      start: '0 20%',
      end: '100% 20%',
      animation: tl,
    })
  })
}

export const initBuildLines = () => {
  $('.js-generate-line').remove()

  // create lines
  const blocks = getCoorsDots($('.js-nav-help-block'))
  blocks.map((elem, index) => {
    const current = elem
    const next = blocks[index + 1]

    if (!next) return

    createLine(current, next)
  })

  // animate lines
  animateLines()
}
